import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import HorizontalForm from './components/ErpVsJarvisInventoryItemLevel';

const ErpVsJarvisInventory = ({ t }) => (
  <Container>
    <Row>
      {/* <Col md={12}>
        <h3 className="page-title">REPORTS - ERP VS JARVIS Inventory Report At Brand Level </h3>
      </Col> */}
    </Row>
   
    <Row>
      <HorizontalForm />
    </Row>

    
  </Container>
);

ErpVsJarvisInventory.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(ErpVsJarvisInventory);
